import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetTkv2OrderPairedCostSettingsAPIError,
  GetTkv2OrderPairedCostSettingsAPIVariables,
  fetchGetTkv2OrderPairedCostSettingsAPI,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getTkv2OrderPairedCostSettingsAPI;

export function useGetTkv2OrderPairedCostSettingsAPI(
  variables: GetTkv2OrderPairedCostSettingsAPIVariables,
  opts?: UseQueryOptions<Response, GetTkv2OrderPairedCostSettingsAPIError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetTkv2OrderPairedCostSettingsAPIError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}/pairedCostSettings',
      operationId: 'getTkv2OrderPairedCostSettingsAPI',
      variables,
    }),
    async () => {
      const res = await fetchGetTkv2OrderPairedCostSettingsAPI({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
